// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#toolbar {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 56px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px 0;
  background: rgba(15, 15, 30, 0.85);
  backdrop-filter: blur(8px);
  border-right: 1px solid rgba(100, 100, 160, 0.3);
  z-index: 10;
}

#toolbar.hidden,
#undo-btn.hidden,
#top-right-btns.hidden {
  display: none;
}

.toolbar-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border: 1px solid rgba(100, 100, 160, 0.3);
  border-radius: 8px;
  background: rgba(30, 30, 60, 0.6);
  color: #8888bb;
  cursor: pointer;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
}

.toolbar-btn:hover {
  background: rgba(50, 50, 90, 0.8);
  color: #aaaadd;
}

.toolbar-btn.active {
  background: rgba(70, 70, 140, 0.6);
  border-color: rgba(130, 130, 200, 0.6);
  color: #ddddff;
}

.toolbar-icon {
  font-size: 18px;
  line-height: 1;
}

.toolbar-label {
  font-size: 9px;
  line-height: 1;
  margin-top: 2px;
  font-family: system-ui, sans-serif;
}

#undo-btn {
  position: absolute;
  top: 12px;
  left: 68px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid rgba(100, 100, 160, 0.3);
  background: rgba(15, 15, 30, 0.85);
  backdrop-filter: blur(8px);
  color: #8888bb;
  font-size: 18px;
  cursor: pointer;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s, color 0.15s;
}

#undo-btn:hover {
  background: rgba(50, 50, 90, 0.8);
  color: #aaaadd;
}

#undo-btn:disabled {
  opacity: 0.3;
  cursor: default;
}

#top-right-btns {
  position: absolute;
  top: 12px;
  right: 12px;
  display: flex;
  gap: 8px;
  z-index: 10;
}

.action-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid rgba(100, 100, 160, 0.3);
  background: rgba(15, 15, 30, 0.85);
  backdrop-filter: blur(8px);
  color: #8888bb;
  font-size: 18px;
  cursor: pointer;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s, color 0.15s;
}

.action-btn:hover {
  background: rgba(50, 50, 90, 0.8);
  color: #aaaadd;
}
`, "",{"version":3,"sources":["webpack://./src/editor/toolbar.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,kCAAkC;EAClC,0BAA0B;EAC1B,gDAAgD;EAChD,WAAW;AACb;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,iCAAiC;EACjC,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,wCAAwC;EACxC,6DAA6D;AAC/D;;AAEA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,kCAAkC;EAClC,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,wCAAwC;EACxC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,kCAAkC;EAClC,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC;EACjC,cAAc;AAChB","sourcesContent":["#toolbar {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 56px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 16px 0;\n  background: rgba(15, 15, 30, 0.85);\n  backdrop-filter: blur(8px);\n  border-right: 1px solid rgba(100, 100, 160, 0.3);\n  z-index: 10;\n}\n\n#toolbar.hidden,\n#undo-btn.hidden,\n#top-right-btns.hidden {\n  display: none;\n}\n\n.toolbar-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  border: 1px solid rgba(100, 100, 160, 0.3);\n  border-radius: 8px;\n  background: rgba(30, 30, 60, 0.6);\n  color: #8888bb;\n  cursor: pointer;\n  touch-action: manipulation;\n  -webkit-tap-highlight-color: transparent;\n  transition: background 0.15s, color 0.15s, border-color 0.15s;\n}\n\n.toolbar-btn:hover {\n  background: rgba(50, 50, 90, 0.8);\n  color: #aaaadd;\n}\n\n.toolbar-btn.active {\n  background: rgba(70, 70, 140, 0.6);\n  border-color: rgba(130, 130, 200, 0.6);\n  color: #ddddff;\n}\n\n.toolbar-icon {\n  font-size: 18px;\n  line-height: 1;\n}\n\n.toolbar-label {\n  font-size: 9px;\n  line-height: 1;\n  margin-top: 2px;\n  font-family: system-ui, sans-serif;\n}\n\n#undo-btn {\n  position: absolute;\n  top: 12px;\n  left: 68px;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 1px solid rgba(100, 100, 160, 0.3);\n  background: rgba(15, 15, 30, 0.85);\n  backdrop-filter: blur(8px);\n  color: #8888bb;\n  font-size: 18px;\n  cursor: pointer;\n  touch-action: manipulation;\n  -webkit-tap-highlight-color: transparent;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.15s, color 0.15s;\n}\n\n#undo-btn:hover {\n  background: rgba(50, 50, 90, 0.8);\n  color: #aaaadd;\n}\n\n#undo-btn:disabled {\n  opacity: 0.3;\n  cursor: default;\n}\n\n#top-right-btns {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  display: flex;\n  gap: 8px;\n  z-index: 10;\n}\n\n.action-btn {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 1px solid rgba(100, 100, 160, 0.3);\n  background: rgba(15, 15, 30, 0.85);\n  backdrop-filter: blur(8px);\n  color: #8888bb;\n  font-size: 18px;\n  cursor: pointer;\n  touch-action: manipulation;\n  -webkit-tap-highlight-color: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.15s, color 0.15s;\n}\n\n.action-btn:hover {\n  background: rgba(50, 50, 90, 0.8);\n  color: #aaaadd;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
